import * as React from 'react';

const ArrowTopIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M16.1826 9.30772L15.1884 10.2737L11.6874 6.77275V17.875H10.3125V6.77275L6.81148 10.2737L5.81726 9.30772L10.9999 4.12504L16.1826 9.30772Z"
      fill="#616161"
    />
  </svg>
);

export default ArrowTopIcon;
